function isFontInstalled(font) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d')!;
  
  // 默认使用 sans-serif 渲染
  ctx.font = '72px sans-serif';
  const defaultWidth = ctx.measureText('Hello').width;
  
  // 尝试使用目标字体
  ctx.font = `72px ${font}, sans-serif`;
  const newWidth = ctx.measureText('Hello').width;
  
  // 如果宽度不同，说明字体可能可用
  return newWidth !== defaultWidth;
}

export function getFonts() {
  // 常用字体
  const normalFontList = [
    'Georgia',
    'Helvetica',
    'Impact',
    'Monaco',
    'Didot',
    'Serif',
    'Tahoma',
    'Verdana',
    'Arial',
    'Lucida Grande',
    'Times New Roman',
    'Courier New',
    'Microsoft YaHei',
    'Hiragino Sans GB',
    'SimSun'
  ];

  return normalFontList.filter(isFontInstalled).join(',');
}
